(function () {
  if (window.TuffStorefrontAnalyticsLoaded) return;
  window.TuffStorefrontAnalyticsLoaded = true;

  var config = window.TuffStorefrontAnalytics || {};
  if (window.Shopify && window.Shopify.designMode && config.trackDesignMode !== true) return;

  var endpoint = config.endpoint || "https://tuff-os-production-c13a.up.railway.app/api/storefront-events";
  var visitorKey = "tuff_storefront_visitor_id_v1";
  var sessionKey = "tuff_storefront_session_id_v1";
  var lastQuickAdd = null;
  var activeSwipe = null;

  function randomId(prefix) {
    var cryptoObject = window.crypto || window.msCrypto;
    if (cryptoObject && cryptoObject.randomUUID) return prefix + "_" + cryptoObject.randomUUID();
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2);
  }

  function storageGet(storage, key, prefix) {
    try {
      var value = storage.getItem(key);
      if (value) return value;
      value = randomId(prefix);
      storage.setItem(key, value);
      return value;
    } catch (error) {
      return randomId(prefix);
    }
  }

  function visitorId() {
    return storageGet(window.localStorage, visitorKey, "visitor");
  }

  function sessionId() {
    return storageGet(window.sessionStorage, sessionKey, "session");
  }

  function deviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 768) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
  }

  function handleFromUrl(href, segment) {
    if (!href) return null;
    try {
      var url = new URL(href, window.location.origin);
      var parts = url.pathname.split("/").filter(Boolean);
      var index = parts.indexOf(segment);
      return index >= 0 && parts[index + 1] ? decodeURIComponent(parts[index + 1]) : null;
    } catch (error) {
      return null;
    }
  }

  function currentCollectionHandle() {
    return handleFromUrl(window.location.pathname, "collections");
  }

  function pageType() {
    if (window.location.pathname.indexOf("/collections/") === 0) return "collection";
    if (window.location.pathname.indexOf("/products/") === 0) return "product";
    if (window.location.pathname === "/" || window.location.pathname === "") return "home";
    return "other";
  }

  function textFrom(element, selector) {
    var node = element && selector ? element.querySelector(selector) : element;
    return node ? node.textContent.replace(/\s+/g, " ").trim() : null;
  }

  function productContext(element) {
    var block = element ? element.closest("product-block, .product-block, [data-product-id]") : null;
    var link = element && element.matches && element.matches('a[href*="/products/"]')
      ? element
      : block
        ? block.querySelector('a[href*="/products/"]')
        : element
          ? element.closest('a[href*="/products/"]')
          : null;
    var href = link ? link.getAttribute("href") : null;
    var label = element ? element.getAttribute("aria-label") : null;
    var title = block ? textFrom(block, ".product-block__title") : null;

    return {
      productHandle: handleFromUrl(href, "products"),
      productTitle: title || label || (link ? textFrom(link) : null),
      productId: block ? block.getAttribute("data-product-id") : null,
      properties: {
        href: href || undefined
      }
    };
  }

  function collectionCardContext(card) {
    var href = card ? card.getAttribute("href") : null;
    return {
      targetCollectionHandle: handleFromUrl(href, "collections"),
      targetCollectionTitle: textFrom(card, ".tuff-collection-card__title"),
      placement: "collection_top_rail",
      properties: {
        href: href || undefined
      }
    };
  }

  function baseEvent(eventName, data) {
    return Object.assign({
      eventName: eventName,
      eventSource: config.eventSource || "shopify_theme",
      visitorId: visitorId(),
      sessionId: sessionId(),
      pagePath: window.location.pathname,
      pageUrl: window.location.href,
      pageType: pageType(),
      collectionHandle: currentCollectionHandle(),
      collectionTitle: textFrom(document, "h1"),
      deviceType: deviceType(),
      viewportWidth: window.innerWidth || null,
      themeId: config.themeId || (window.Shopify && window.Shopify.theme ? String(window.Shopify.theme.id || "") : null),
      themeRole: config.themeRole || (window.Shopify && window.Shopify.theme ? String(window.Shopify.theme.role || "") : null),
      properties: {}
    }, data || {});
  }

  function postEvent(eventName, data) {
    if (!endpoint) return;
    var event = baseEvent(eventName, data);
    event.properties = Object.assign({
      referrer: document.referrer || undefined,
      designMode: Boolean(window.Shopify && window.Shopify.designMode),
      previewThemeId: new URLSearchParams(window.location.search).get("preview_theme_id") || undefined
    }, data && data.properties ? data.properties : {});

    var payload = JSON.stringify(event);
    if (navigator.sendBeacon) {
      var blob = new Blob([payload], { type: "application/json" });
      if (navigator.sendBeacon(endpoint, blob)) return;
    }

    try {
      window.fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: payload,
        keepalive: true,
        credentials: "omit"
      }).catch(function () {});
    } catch (error) {}
  }

  window.TuffTrackStorefrontEvent = postEvent;

  function bodyValue(body, name) {
    if (!body || !name) return null;
    try {
      if (window.FormData && body instanceof FormData) return body.get(name);
      if (window.URLSearchParams && body instanceof URLSearchParams) return body.get(name);
      if (typeof body === "string") return new URLSearchParams(body).get(name);
    } catch (error) {}
    return null;
  }

  function cartContextFromBody(body) {
    var recent = lastQuickAdd && Date.now() - lastQuickAdd.at < 30000 ? lastQuickAdd : null;
    return Object.assign({}, recent || {}, {
      variantId: String(bodyValue(body, "id") || bodyValue(body, "items[0][id]") || ""),
      placement: recent ? "product_grid_quick_add" : "cart_add_request"
    });
  }

  function isCartAddUrl(input) {
    var raw = typeof input === "string" ? input : input && input.url ? input.url : "";
    if (!raw) return false;
    try {
      return new URL(raw, window.location.origin).pathname.indexOf("/cart/add") === 0;
    } catch (error) {
      return raw.indexOf("/cart/add") >= 0;
    }
  }

  function trackCartResult(ok, status, body, responsePayload) {
    var context = cartContextFromBody(body);
    var eventData = Object.assign({}, context, {
      properties: Object.assign({}, context.properties || {}, {
        status: status,
        responseProductId: responsePayload && responsePayload.product_id ? String(responsePayload.product_id) : undefined,
        responseVariantId: responsePayload && responsePayload.variant_id ? String(responsePayload.variant_id) : undefined
      })
    });

    postEvent(ok ? "add_to_cart_success" : "add_to_cart_failed", eventData);
    if (context.productHandle || context.placement === "product_grid_quick_add") {
      postEvent(ok ? "quick_add_success" : "quick_add_failed", eventData);
    }
  }

  function filterContext(input) {
    if (!input || !input.name || input.name.indexOf("filter.") !== 0) return null;
    return {
      placement: "collection_filter",
      properties: {
        filterName: input.name,
        filterValue: input.value || undefined,
        checked: typeof input.checked === "boolean" ? input.checked : undefined
      }
    };
  }

  function sortContext(input) {
    if (!input || input.name !== "sort_by") return null;
    return {
      placement: "collection_sort",
      properties: {
        sortValue: input.value || undefined
      }
    };
  }

  function installCollectionCardClickFallback() {
    if (window.TuffCollectionCardRailClickFallbackLoaded) return;
    window.TuffCollectionCardRailClickFallbackLoaded = true;

    var pendingCard = null;

    document.addEventListener("pointerdown", function (event) {
      var card = event.target && event.target.closest
        ? event.target.closest(".tuff-collection-card-rail .tuff-collection-card")
        : null;
      var href = card ? card.getAttribute("href") : null;
      if (!card || !href) {
        pendingCard = null;
        return;
      }

      pendingCard = {
        id: event.pointerId,
        card: card,
        href: href,
        x: event.clientX,
        y: event.clientY,
        at: Date.now()
      };
    }, true);

    document.addEventListener("pointerup", function (event) {
      if (!pendingCard || pendingCard.id !== event.pointerId) return;

      var card = pendingCard.card;
      var href = pendingCard.href;
      var dx = Math.abs(event.clientX - pendingCard.x);
      var dy = Math.abs(event.clientY - pendingCard.y);
      var elapsed = Date.now() - pendingCard.at;
      pendingCard = null;

      if (!href || dx > 12 || dy > 12 || elapsed > 1200) return;

      postEvent("collection_card_clicked", collectionCardContext(card));
      window.location.href = href;
    }, true);

    document.addEventListener("pointercancel", function () {
      pendingCard = null;
    }, true);
  }

  installCollectionCardClickFallback();

  document.addEventListener("click", function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var quickAdd = target.closest(".tuff-card-quick-add");
    if (quickAdd) {
      var quickAddContext = Object.assign(productContext(quickAdd), {
        placement: "product_grid_quick_add",
        properties: Object.assign({}, productContext(quickAdd).properties, {
          ariaLabel: quickAdd.getAttribute("aria-label") || undefined
        })
      });
      lastQuickAdd = Object.assign({ at: Date.now() }, quickAddContext);
      postEvent("quick_add_clicked", quickAddContext);
      return;
    }

    var collectionCard = target.closest(".tuff-collection-card");
    if (collectionCard) {
      postEvent("collection_card_clicked", collectionCardContext(collectionCard));
      return;
    }

    var productLink = target.closest('product-block a[href*="/products/"], .product-block a[href*="/products/"]');
    if (productLink) {
      postEvent("product_card_clicked", Object.assign(productContext(productLink), {
        placement: "collection_product_card"
      }));
    }
  }, true);

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input || !input.name) return;

    var filterData = filterContext(input);
    if (filterData) {
      postEvent("collection_filter_changed", filterData);
      return;
    }

    var sortData = sortContext(input);
    if (sortData) {
      postEvent("collection_sort_changed", sortData);
    }
  }, true);

  document.addEventListener("pointerdown", function (event) {
    var slider = event.target && event.target.closest ? event.target.closest(".tuff-collection-card-rail__slider") : null;
    if (!slider) return;
    activeSwipe = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      at: Date.now()
    };
  }, true);

  document.addEventListener("pointerup", function (event) {
    if (!activeSwipe || activeSwipe.id !== event.pointerId) return;
    var dx = event.clientX - activeSwipe.x;
    var dy = event.clientY - activeSwipe.y;
    var elapsed = Date.now() - activeSwipe.at;
    activeSwipe = null;
    if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy)) return;
    postEvent("collection_rail_swiped", {
      placement: "collection_top_rail",
      properties: {
        direction: dx < 0 ? "next" : "previous",
        distance: Math.round(Math.abs(dx)),
        elapsedMs: elapsed
      }
    });
  }, true);

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var isCartAdd = isCartAddUrl(input);
      var body = init && init.body ? init.body : input && input.body ? input.body : null;
      var promise = originalFetch.apply(this, arguments);
      if (!isCartAdd) return promise;

      return promise.then(function (response) {
        var clone = response.clone();
        clone.json().then(function (json) {
          trackCartResult(response.ok, response.status, body, json);
        }).catch(function () {
          trackCartResult(response.ok, response.status, body, null);
        });
        return response;
      }).catch(function (error) {
        trackCartResult(false, 0, body, { error: error && error.message ? error.message : "fetch_failed" });
        throw error;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__tuffAnalyticsUrl = url;
      this.__tuffAnalyticsMethod = method;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isCartAddUrl(this.__tuffAnalyticsUrl)) {
        var xhr = this;
        xhr.addEventListener("loadend", function () {
          var parsed = null;
          try {
            parsed = xhr.responseText ? JSON.parse(xhr.responseText) : null;
          } catch (error) {}
          trackCartResult(xhr.status >= 200 && xhr.status < 300, xhr.status, body, parsed);
        });
      }
      return originalSend.apply(this, arguments);
    };
  }
})();
